import Team from '../components/pages/Team/Team';
export default Team;
